import React, { useEffect } from "react";
import { HashRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import Faculty from "./pages/Faculty";
import Results from "./pages/Results";
import Contact from "./pages/Contact";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminGallery from "./admin/AdminGallery";
import AdminToppers from "./admin/AdminToppers";
import AdminTestimonials from "./admin/AdminTestimonials";
import AdminEnquiries from "./admin/AdminEnquiries";
import AdminContent from "./admin/AdminContent";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("admin_token");
  return token ? children : <Navigate to="/admin" replace />;
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        {/* Admin routes (no Navbar/Footer) */}
        
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/*" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>} >
            
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="toppers" element={<AdminToppers />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="content" element={<AdminContent />} />
          </Route> 
        {/* Public routes */}

        <Route index element={<><Navbar /><Home /><Footer /><WhatsAppButton /></>} />
        
        <Route path="/about" element={<><Navbar /><About /><Footer /><WhatsAppButton /></>} />
        
        <Route path="/courses" element={<><Navbar /><Courses /><Footer /><WhatsAppButton /></>} />
        
        <Route path="/faculty" element={<><Navbar /><Faculty /><Footer /><WhatsAppButton /></>} />
        
        <Route path="/results" element={<><Navbar /><Results /><Footer /><WhatsAppButton /></>} />
        
        <Route path="/contact" element={<><Navbar /><Contact /><Footer /><WhatsAppButton /></>} />
       
      </Routes>
    </HashRouter>
  );
}

export default App;
